module.exports = __webpack_public_path__ + "img/cmbs-chronicle-sep-13-2021-single.43503818.png";